import { BrandPage } from './BrandPage';
export default BrandPage;
export * from './BrandPage';
